import axios from 'axios'

const USERKEY = '_horsgle_srn'

const temKey = () => localStorage.getItem(USERKEY) !== null

const autenticacaoStorage = {
  adicionaAuthorization(token, role) {
    axios.defaults.headers.common.Authorization = token
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common.Role = role
  },

  getUserObj() {
    if (temKey()) {
      const userObj = JSON.parse(localStorage.getItem(USERKEY))
      this.adicionaAuthorization(userObj.token, userObj.usuario.role)
    }

    return temKey() ? JSON.parse(localStorage.getItem(USERKEY)) : ''
  },

  setUserObj(userObj) {
    localStorage.setItem(USERKEY, JSON.stringify(userObj))
    this.adicionaAuthorization(userObj.token, userObj.usuario.role)
  },

  removeUserObj() {
    if (temKey()) {
      localStorage.removeItem(USERKEY)
    }

    delete axios.defaults.headers.common.Authorization
  },
}

export default autenticacaoStorage
